import { Component, Input, OnInit, HostListener, OnChanges, SimpleChanges } from '@angular/core';
import { LandingPage } from 'src/app/models/firebase/landing-page';
import { Testimonial } from 'src/app/models/firebase/testimonial';
import { AuthService } from 'src/app/service/auth/auth.service';
import { TestimonialsService } from 'src/app/service/testimonials/testimonials.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-our-team',
  templateUrl: './our-team.component.html',
  styleUrls: ['./our-team.component.scss']
})
export class OurTeamComponent implements OnInit, OnChanges {

  @Input() ourTeamData: LandingPage = null;
  testimonials: Testimonial[] = [];
  shortTestimonials: LandingPage.IBasicTestimonial[] = [];
  screenWidth: number;
  screenHeight: number;

  constructor(
    private authService: AuthService,
    private testimonialService: TestimonialsService,
    private router: Router
  ) { }

  async ngOnInit(): Promise<void> {
    this.getScreenSize();
    this.findShortTestimonialsToShowInHomeSection()
    this.getTestimonialsHomePage()
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['ourTeamData']) {
      this.findShortTestimonialsToShowInHomeSection();
    }
  }

  findShortTestimonialsToShowInHomeSection() {
    this.ourTeamData?.testimonialsList?.list.forEach(item => {
      if(item.description.length < 180) {
        this.shortTestimonials.push(item)
      } else {
        return null;
      }
    })
  }

  async getTestimonialsHomePage(){
    this.testimonials =  await this.testimonialService.getTestimonialsHomePage(this.authService.projectId)
  }

  @HostListener('window:resize', ['$event'])
  getScreenSize(event?: Event): void {
    this.screenWidth = window.innerWidth;
    this.screenHeight = window.innerHeight;
  }

  navigate(){
    this.router.navigate(['/testimonials'])
  }
}
